/**
 * Exports textarea-related design tokens
 */

export const defaultRows = 8;